import { callBackendApi } from "../axiosInstances/backendInstance/apiRequest";

export async function getUsers() {
    return await callBackendApi('/users', 'GET');
}

export async function getUserById(id) {
    return await callBackendApi('/users/' + id, 'GET');
}